export interface Transfer {
  id: number;
  revision: number;
  lifecycle_version: number;
  reference: string;
  status: string;
  from_warehouse_id: number;
  to_warehouse_id: number;
  from_warehouse_name: string;
  to_warehouse_name: string;
  requested: number;
  shipped: number;
  received: number;
  damaged: number;
  cancelled: number;
  lost: number;
  returned: number;
  held: number;
  item_count: number;
  invalid_items: number;
  reason: string | null;
  priority: number;
  notes: string | null;
  expected_ship_date: string | null;
  expected_arrival_date: string | null;
  inventory_publication: string;
  carrier: string | null;
  tracking_number: string | null;
  source_mapped: number;
  destination_mapped: number;
}
export interface TransferItem {
  id: number;
  product_id: number;
  product_sku: string | null;
  product_title: string;
  from_location_id: number;
  from_location_name: string | null;
  to_location_id: number | null;
  to_location_name: string | null;
  quantity_requested: number;
  quantity_shipped: number;
  quantity_received: number;
  quantity_damaged: number;
  quantity_cancelled: number;
  quantity_lost: number;
  quantity_returned: number;
  available: number;
  reserved: number;
  untracked: number;
  shopify_mapped: number;
  inventory_job_status: string | null;
}
export interface TransferDetail {
  transfer: Transfer;
  items: TransferItem[];
  nextCursor: number | null;
  canEdit: boolean;
}
export interface TransferEvent {
  id: number;
  action: string;
  actor_name: string;
  created_at: string;
  details: {
    reason?: string;
    reference?: string;
    lines?: { itemId: number; quantity: number; damaged: number; locationId?: number; holdingId?: number }[];
    receiptId?: number;
    quantity?: number;
    locationId?: number;
  };
}
export interface Holding {
  id: number;
  item_id: number;
  untracked: number;
  sku: string | null;
  title: string;
  holding_bin: string;
  remaining: number;
}
export const transit = (item: TransferItem) =>
  item.quantity_shipped - item.quantity_received - item.quantity_damaged - item.quantity_lost - item.quantity_returned;
export const unshipped = (item: TransferItem) =>
  item.quantity_requested - item.quantity_shipped - item.quantity_cancelled;
